module.exports = __webpack_public_path__ + "img/20190705162426379.0412a114.png";